import axios from 'axios'
import { checkLogin, CONST, errorHandler } from './depends'
const Config = process.env
export default async function getUserInfo() {
  try {
    const response = await axios(`${Config.VUE_APP_SSO}sso/verify`, {
      method: 'GET',
      withCredentials: true,
      params: {
        passport: ''
      }
    })
    const data = response.data
    if (data && data.result && data.result.user) {
      return data.result.user
    }
    // 登录异常，强制重新登录
    errorHandler(CONST.needLogin, '未获取到登录信息，请重新登录')
  } catch (e) {
    errorHandler(CONST.needLogin, e.message)
  }
}
